import React, { memo, useEffect, useState } from 'react';
import { createSelector } from 'reselect';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import classNames from 'classnames';
import { CONTEXT } from '../../config';
import styles from './Nav.module.less';
import { logging, logPostInfo } from '../../actions/log';
import { PCStoreJsBridge } from '../../nativeapi';
import EquityTag from './WallpaperComponents/EquityTag';
import { getVipState, setShowWpExchange } from '../../actions/wallpaperPay';
import useLoginStatus from '../../utils/hooks/useLoginStatus';
import { handleLogin } from '../../utils/hooks/useLoginStatus';
import { emptyLoginClose } from '../../actions/user';

const tabs = [
  {
    text: '精选',
    name: 'wprecommend',
    icon: 'icon-recommend1_15',
    url: 'wprecommend',
    active: 'wprecommend',
  },
  {
    text: '热门',
    name: 'wphot',
    icon: 'icon-recommend1_15',
    url: 'wphot',
    active: 'wphot',
  },
  {
    text: '排行',
    name: 'wprankpage',
    icon: 'icon-recommend1_15',
    url: 'wprankpage',
    active: 'wprankpage',
  },
  {
    text: '分类',
    name: 'wpcategory',
    icon: 'icon-category1_15',
    url: 'wpcategory',
    active: 'wpcategory',
  },
  {
    text: '我的',
    name: 'wpmine',
    icon: 'icon-menu_wallpaper',
    url: 'wpmine/setup',
    active: 'wpmine',
  },
];

const mineTabs = [
  {
    tagId: 'setup',
    name: '曾用壁纸',
    url: '/setup',
  },
  {
    tagId: 'collect',
    name: '我收藏的',
    url: '/collect',
  },
  {
    tagId: 'loop',
    name: '壁纸轮播',
    url: '/turn',
  },
  {
    tagId: 'paylist',
    name: '壁纸订单',
    url: '/paylist',
  },
];

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

const selectLoginClose = createSelector(
  state => state.user,
  user => user.loginBoxClose,
);

export default memo(({ active = 'wprecommend' }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);
  const { pathname } = useLocation();
  const loginBoxClose = useSelector(selectLoginClose);
  const [isExchange, setIsExchange] = useState(false);
  const loginStatus = useLoginStatus();

  useEffect(() => {
    dispatch(getVipState());
  }, []);

  useEffect(() => {
    if (loginStatus && isExchange && loginBoxClose?.result === 1) {
      dispatch(setShowWpExchange(true));
      dispatch(emptyLoginClose());
      setIsExchange(false);
    }
    if (!loginStatus && isExchange && loginBoxClose?.result === 0) {
      setIsExchange(false);
      dispatch(emptyLoginClose());
    }
  }, [loginStatus, isExchange, loginBoxClose]);

  const handleClick = info => {
    history.push(`${CONTEXT}/wallpaper/${info.url}`);
    dispatch(
      logging({
        category: 'Wallpaper',
        action: 'C_Wallpaper_Menu',
        label: '',
        param2: {
          source: logInfoData.source,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          menuType: info.url,
        },
      }),
    );

    dispatch(
      logPostInfo({
        source_p: logInfoData.source,
        source_pp: logInfoData.source_p,
      }),
    );
  };

  const handleInto = el => {
    history.push(`${CONTEXT}/wallpaper/wpmine${el.url}`);

    dispatch(
      logging({
        category: 'Wallpaper',
        action: 'C_Wallpaper_Mine_Tag',
        param2: {
          source: `Wallpaper_Mine||${el.tagId}`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          tagId: el.tagId,
        },
      }),
    );
    dispatch(
      logPostInfo({
        source: `Wallpaper_Mine||${el.tagId}`,
        source_p: logInfoData.source_p,
        source_pp: logInfoData.source_pp,
      }),
    );
  };

  const handleOpenPath = () => {
    PCStoreJsBridge.getWallpaperDPath({}).then(ret => {
      if (ret && ret.defpath) {
        PCStoreJsBridge.openFolder(ret.workpath || ret.defpath);
      }
    });

    dispatch(
      logging({
        category: 'Wallpaper',
        action: 'C_Wallpaper_Openpath',
        param2: {
          source: `Wallpaper_Mine||paylist`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          tagId: 'paylist',
        },
      }),
    );
  };

  const handleCustomer = () => {
    dispatch(
      logging({
        category: 'Wallpaper',
        action: 'C_Wallpaper_Ordererr',
        param2: {
          source: `Wallpaper_Mine||paylist`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          tagId: 'paylist',
        },
      }),
    );
    window.open(`https://wpa1.qq.com/z914HEIy?_type=wpa&qidian=true}`);
  };

  const handleExchange = () => {
    dispatch(
      logging({
        category: 'Wallpaper',
        action: 'C_Wallpaper_Convert',
        param2: {
          source: `Wallpaper_Mine||paylist`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
    setIsExchange(true);
    if (loginStatus) {
      dispatch(setShowWpExchange(true));
    } else {
      handleLogin();
    }
  };

  return (
    <div className={`${styles.nav}`}>
      <div
        className={`${styles.nav_menu}  ${active === 'wpmine' ? styles.nav_mine : ''}  ${
          active === 'wpcategory' ? styles.nav_collect_menu : ''
        }`}
      >
        <div className={styles.nav_menu_left}>
          <div className={styles.nav_tab}>
            {tabs.map(item => (
              <div
                key={item.name}
                className={`${styles.nav_item} ${active === item.active ? styles.item_active : ''}`}
                onClick={() => handleClick(item)}
              >
                {item.text}
              </div>
            ))}
          </div>
          {active === 'wpmine' && (
            <div className={styles.tabs}>
              {mineTabs.map(el => (
                <div
                  key={el.name}
                  className={`${styles.tab_item} ${
                    pathname === `${CONTEXT}/wallpaper/wpmine${el.url}` ? styles.tab_active : ''
                  } `}
                  onClick={() => handleInto(el)}
                >
                  {el.name}
                </div>
              ))}
            </div>
          )}
        </div>
        <div>
          {active === 'wpmine' && <EquityTag />}
          {pathname === `${CONTEXT}/wallpaper/wpmine/paylist` && (
            <div className={styles.pay_opt}>
              <div
                className={`${styles.pay_opt_item} ${styles.pay_opt_item_}`}
                onClick={handleExchange}
              >
                <span className={styles.pay_opt_path_ex} />
                <span>兑换订阅服务</span>
              </div>
              <div
                className={`${styles.pay_opt_item} ${styles.pay_opt_item_}`}
                onClick={handleOpenPath}
              >
                <span className={styles.pay_opt_path_wj} />
                <span>打开下载目录</span>
              </div>
              <div className={styles.pay_opt_item} onClick={handleCustomer}>
                <span className={styles.pay_opt_path_wt} />
                <span>订单异常</span>
              </div>
            </div>
          )}
        </div>
      </div>
      {/* {active === 'wpmine' && <div className={styles.line} />} */}
    </div>
  );
});
